import { DotsFilledIcon } from '@approvalmax/ui';
import { Button, Dropdown, Menu, MenuItemProps, Popup } from '@approvalmax/ui/src/components';
import { miscHelpers } from '@approvalmax/utils';
import { memo, useCallback, useMemo } from 'react';
import { useToggle } from 'react-use';

import { AddCurrenciesPopupContent } from '../AddCurrenciesPopupContent/AddCurrenciesPopupContent';
import { BankStatementReportPopupContent } from '../BankStatementReportPopupContent/BankStatementReportPopupContent';
import { messages } from './DropdownMenu.messages';

export const DropdownMenu = memo(() => {
    const [isAddCurrenciesPopupOpen, setIsAddCurrenciesPopupOpen] = useToggle(false);
    const [isBankStatementReportPopupOpen, setIsBankStatementReportPopupOpen] = useToggle(false);

    const items = useMemo<MenuItemProps[]>(
        () => [
            {
                name: messages.addCurrency,
                onClick: () => {
                    setIsAddCurrenciesPopupOpen(true);
                },
            },
            {
                name: messages.bankStatementReport,
                onClick: () => {
                    setIsBankStatementReportPopupOpen(true);
                },
            },
            {
                name: messages.transactions,
                onClick: miscHelpers.noop,
            },
        ],
        [setIsAddCurrenciesPopupOpen, setIsBankStatementReportPopupOpen]
    );

    const handleCloseAddCurrenciesPopup = useCallback(() => {
        setIsAddCurrenciesPopupOpen(false);
    }, [setIsAddCurrenciesPopupOpen]);

    return (
        <>
            <Dropdown
                closeOnClickInnerButton
                width='max-content'
                activator={
                    <Button icon noPadding variant='text' color='blue100'>
                        <DotsFilledIcon />
                    </Button>
                }
            >
                <Menu items={items} size='small' />
            </Dropdown>

            <Popup open={isAddCurrenciesPopupOpen} size='small' onToggle={setIsAddCurrenciesPopupOpen}>
                <AddCurrenciesPopupContent onClosePopup={handleCloseAddCurrenciesPopup} />
            </Popup>

            <Popup open={isBankStatementReportPopupOpen} size='small' onToggle={setIsBankStatementReportPopupOpen}>
                <BankStatementReportPopupContent />
            </Popup>
        </>
    );
});

DropdownMenu.displayName = 'DropdownMenu';
